import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreatePaymentType from "./create/createPaymentType";
import UpdatePaymentType from "./update/updatePaymentType";

const PaymentTypeContext = createContext();

function PaymentType() {

  const [dataList, setDataList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.PaymentType.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowData(results);
      else 
      setShowData(dataList);
    } else 
    setShowData(dataList);
  }

  const openUpdate = (PaymentTypeID, PaymentType) => {
    var list = [];
    list.push({
      PaymentTypeID: PaymentTypeID,
      PaymentType: PaymentType
    });
    setData(list);
    setShowUpdate(true);
  };
  
  useEffect(() => {
    let userData = localStorage.getItem("paymentTypeData");
    if (userData) {
      let userRole = JSON.parse(userData);
      setDataList(userRole);
      setShowData(userRole);
    }
  }, []);

  return (
    <PaymentTypeContext.Provider value={{dataList, setDataList, data}}>
      <div className="formContent">
        <CreatePaymentType show={show} onClick={handleClose}/>
        <UpdatePaymentType show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ປະເພດຈ່າຍ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ປະເພດຈ່າຍ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.PaymentType}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.PaymentTypeID} type="button" onClick={() => openUpdate(x.PaymentTypeID, x.PaymentType)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </PaymentTypeContext.Provider>
  );
};

export {PaymentTypeContext};
export default PaymentType;
